import { connect } from 'react-redux';
import { openCountryCurrencySettings } from 'shared/store/internationalization/actions';
import { getUserI18N } from 'shared/store/internationalization/selectors';

import PromotionalBanner, {
  IPromotionalBannerStateProps,
  IPromotionalBannerDispatchProps,
} from './PromotionalBanner';

const mapStateToProps = (state: any) => ({
  selectedCurrency: getUserI18N(state).currency,
  selectedCountry: getUserI18N(state).country,
  currencyDisplayValue: getUserI18N(state).currencyDisplayValue,
});

const mapDispatchToProps = {
  openCountryCurrencySettings,
};

export default connect<IPromotionalBannerStateProps, IPromotionalBannerDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(PromotionalBanner);
